import Service from "../services/service";
import {IRole} from "../interfaces/roleInterfaces";
import {IPersist} from "../interfaces/persistInterfaces";

interface IPersistRole extends IPersist {
  role: IRole;
}

interface IPersistRoles extends IPersist {
  roles: IRole[];
}

interface IMetadata extends IPersist {
  metadata: object;
}

export default class RoleProvider extends Service {
  fetch({organizationId}) {
    return this.persist<IPersistRoles>({json: {organization_id: organizationId}, method: 'get'});
  }

  create({organizationId, roleJson}) {
    return this.persist<IPersistRole>({json: {organization_id: organizationId, role: roleJson}, method: 'post'});
  }

  update({organizationId, roleJson}) {
    return this.persist<IPersistRole>({endpoint: `${roleJson.id}`, json: {organization_id: organizationId, role: roleJson}});
  }

  destroy({organizationId, roleId}: {organizationId: string, roleId: string}) {
    return this.persist<IPersistRole>({endpoint: `${roleId}`, json: {organization_id: organizationId}, method: 'delete'});
  }

  metadata({organizationId, roleId, json}: {organizationId: string, roleId: string, json: object}) {
    return this.persist<IMetadata>({endpoint: `${roleId}/metadata`, json: window.AppConfig.mergeJson(json, {organization_id: organizationId}), method: 'get'});
  }

  private persist<T extends IPersist>({endpoint = '', json = null, method = 'put'}) {
    return new Promise<T>((resolve, reject) => {
      const data = {
        _method: method,
        authenticity_token: this.csrfToken()
      };

      if (json) {
        window.AppConfig.mergeJson(data, json);
      }

      $.ajax({
        url: `/organizations/${json.organization_id}/roles/${endpoint}`,
        type: 'POST',
        dataType: 'json',
        data: data,
      }).done(function (result) {
        resolve(result);
      }).fail(function (result) {
        reject();
      });
    });
  }
}
